import React from 'react';
import { Select } from './controls/Select.jsx';
import { DatePicker } from './controls/DatePicker.jsx';

// One labelled form control, driven by a field descriptor:
//   { key, label, type?, options?, full?, placeholder? }
//   type: 'text' (default) | 'textarea' | 'date' | 'number' | 'select' | 'checkbox'
export function FieldControl({ field, value, onChange }) {
  const common = {
    value: value ?? '',
    onChange: (e) => onChange(e.target.value),
  };

  let control;
  if (field.type === 'textarea') {
    control = <textarea {...common} placeholder={field.placeholder} />;
  } else if (field.type === 'select') {
    control = (
      <Select
        ariaLabel={field.label}
        value={value ?? ''}
        onChange={onChange}
        options={field.options.map((opt) => {
          const [val, label] = Array.isArray(opt) ? opt : [opt, opt];
          return { value: String(val), label: label || '—' };
        })}
      />
    );
  } else if (field.type === 'checkbox') {
    return (
      <label className={`field-control check${field.full ? ' full' : ''}`}>
        <input
          type="checkbox"
          checked={Boolean(value)}
          onChange={(e) => onChange(e.target.checked)}
        />
        {field.label}
      </label>
    );
  } else if (field.type === 'date') {
    control = (
      <DatePicker
        ariaLabel={field.label}
        value={value ?? ''}
        onChange={onChange}
      />
    );
  } else {
    control = (
      <input
        type={field.type || 'text'}
        {...common}
        placeholder={field.placeholder}
      />
    );
  }

  return (
    <label className={`field-control${field.full ? ' full' : ''}`}>
      <span>{field.label}</span>
      {control}
    </label>
  );
}

// A grid of FieldControls over one working object.
export function FieldGrid({ fields, form, setForm }) {
  const set = (key, val) => setForm((c) => ({ ...c, [key]: val }));
  return (
    <div className="field-grid">
      {fields.map((field) => (
        <FieldControl
          key={field.key}
          field={field}
          value={form[field.key]}
          onChange={(val) => set(field.key, val)}
        />
      ))}
    </div>
  );
}
